//mui
import {Theme} from '@mui/material';

export const MuiFormControl = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			width: '100%',

			'& .MuiInputLabel-animated': {
				color: theme.palette.neutral300,
				fontWeight: 700,
				fontSize: 20,
				lineHeight: 'normal',

				'&.Mui-focused, &.MuiFormLabel-filled': {
					color: theme.palette.neutral300,
					fontSize: 12,
					transform: 'translate(12px, 4px) scale(0.75)',
					letterSpacing: '0.4px',
					fontWeight: 400,
				},
			},
		}),
	},
};
